(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("Cw_swiper_library", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["Cw_swiper_library"] = factory(require("vue"));
	else
		root["Cw_swiper_library"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 